import {  
  getFirestore,
  getDocs,
  where,
  collection,
  query
} from "firebase/firestore";
const getProgramNumberByUserId = async function(id) {
  let db = getFirestore();

  let ref = collection(db, "wellness_program");
  
  const queryItem = query( 
    ref,
    where('owner', '==', id)
  );
  const docSnapa = await getDocs(queryItem);
  return docSnapa.size;

};

export default getProgramNumberByUserId;
